import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=48d8253d&scoped=true&lang=pug&"
var script = {}
import style0 from "./Privacy.sass?vue&type=style&index=0&id=48d8253d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d8253d",
  null
  
)

export default component.exports